import { useLoyaltyContext } from '../context/LoyaltyContext'
import React from 'react'
import { SignupForm } from './SignupForm/SignupForm'
import { SignupMethod } from '../types/types'
import { Successful } from './Successful/Successful'
import { InactiveProgram } from '../InactiveProgram/InactiveProgram'
import { Loading } from '../Loading/Loading'
import { ErrorPage500 } from '@toasttab/buffet-pui-error-pages'
import { Layout } from '../Layout/Layout'
import { t } from '@local/translations'

export const SignUp = () => {
  const { configLoading, config, configError, isSignUpSuccess, isSignUpError } =
    useLoyaltyContext()

  if (configError || isSignUpError) return <ErrorPage500 />
  if (configLoading) return <Loading />
  if (!config?.isRewardsEnabled) return <InactiveProgram />
  if (isSignUpSuccess) return <Successful />

  const {
    signUpMethod,
    programName,
    programDescription,
    smsMarketingAccountEnabled,
    restaurantCountryCode
  } = config

  const contactMethod =
    signUpMethod === SignupMethod.EMAIL ? 'email' : 'phone number'

  const isInternational = (restaurantCountryCode ?? 'US') !== 'US'

  return (
    <Layout>
      <h1 className='type-large text-default text-center font-bold'>
        {t('sign-up.heading', { programName })}
      </h1>

      <div className='type-default text-default text-center'>
        {programDescription}
      </div>
      <SignupForm />
      {smsMarketingAccountEnabled &&
        signUpMethod === SignupMethod.PHONE_NUMBER && (
          <div
            className='type-subhead sm:w-2/3 w-full text-center'
            aria-label={t('sign-up.terms.aria-label')}
          >
            {t('sign-up.terms.sms.text')}{' '}
            <a
              className='text-link'
              href='https://pos.toasttab.com/terms-of-service'
            >
              {t('sign-up.terms.sms.toast-terms')}
            </a>{' '}
            {t('sign-up.and')}{' '}
            <a className='text-link' href='https://pos.toasttab.com/privacy'>
              {t('sign-up.terms.toast-privacy-statement')}
            </a>
          </div>
        )}
      {!isInternational &&
        (!smsMarketingAccountEnabled ||
          signUpMethod === SignupMethod.EMAIL) && (
          <div
            className='type-subhead sm:w-2/3 w-full text-center'
            aria-label={t('sign-up.terms.aria-label')}
          >
            {t('sign-up.terms.email.text', { contactMethod })}{' '}
            <a
              className='inline-link'
              href='https://pos.toasttab.com/terms-of-service'
            >
              {t('sign-up.terms.email.toast-terms')}
            </a>{' '}
            {t('sign-up.and')}{' '}
            <a className='inline-link' href='https://pos.toasttab.com/privacy'>
              {t('sign-up.terms.toast-privacy-statement')}
            </a>
          </div>
        )}
      {isInternational &&
        (!smsMarketingAccountEnabled ||
          signUpMethod === SignupMethod.EMAIL) && (
          <div
            className='type-subhead sm:w-2/3 w-full text-center'
            aria-label={t('sign-up.intl-email-marketing-terms.aria-label')}
          >
            {t('sign-up.intl-email-marketing-terms.text')}{' '}
            <a
              className='inline-link'
              href='https://pos.toasttab.com/terms-of-service'
            >
              {t('sign-up.intl-email-marketing-terms.toast-terms')}
            </a>{' '}
            {t('sign-up.and')}{' '}
            <a className='inline-link' href='https://pos.toasttab.com/privacy'>
              {t('sign-up.intl-email-marketing-terms.toast-privacy-statement')}
            </a>{' '}
            {t('sign-up.intl-email-marketing-terms.merchant-terms')}
          </div>
        )}
    </Layout>
  )
}
